import { render, staticRenderFns } from "./CompanyReview.vue?vue&type=template&id=4985c566&scoped=true"
import script from "./CompanyReview.vue?vue&type=script&lang=js"
export * from "./CompanyReview.vue?vue&type=script&lang=js"
import style0 from "./CompanyReview.vue?vue&type=style&index=0&id=4985c566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985c566",
  null
  
)

export default component.exports